module.exports = __webpack_public_path__ + "static/media/chesapeakeregional.261ac0c9.png";